// extracted by css-extract-rspack-plugin
export default {"modal":"bDWUPa","backdrop":"JRgm6e"};